<template>
    <div class="records_no_code">
        <v-container class="my-1">
            <!--    Diálogo Modal para Confirmación Eliminar Invitación        -->
            <v-dialog v-model="dialog_elimnar" max-width="290">
                <v-card>
                    <v-card-title class="headline">
                        {{$t('msg_eliminar_invitacion')}}
                    </v-card-title>

                    <v-card-text>
                        {{$t('msg_eliminar_invitacion_2')}}
                    </v-card-text>

                    <v-card-actions>
                        <v-btn
                                color="primary"
                                @click="dialog_elimnar = false"
                        >
                            No
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                                color="primary"
                                @click="eliminar_invitacion(id_invitacion_eliminar)"
                        >
                            {{$t('Si')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog scrollable v-model="dialog_accesos" max-width="500px">
                <v-card color="blue-grey lighten-4" class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>{{$t('detalle_access')}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialog_accesos = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text v-if="data_accesos.user">
                        <v-img
                                :src="data_accesos.user.ine_frente"
                                position="center center"
                                class="grey lighten-2"
                        ></v-img>
                        <br>
                        <table id="datas">
                            <tr>
                                <th>
                                    <h2>
                                        {{$t('Visitante')}}:
                                    </h2>
                                </th>
                                <td>
                                    <h2>
                                        {{ data_accesos.user.first_name}} {{ data_accesos.user.last_name}}
                                    </h2>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <h2>
                                        {{$t('Caseta')}}:
                                    </h2>
                                </th>
                                <td>
                                    <h2>
                                        {{ data_accesos.guardhouse_name}}
                                    </h2>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <h2>
                                        {{$t('hora_acceso')}}
                                    </h2>
                                </th>
                                <td>
                                    <h2>
                                        {{ data_accesos.dateTime_EntranceAccess}}
                                    </h2>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <h2>
                                        {{$t('hora_salida')}}
                                    </h2>
                                </th>
                                <td>
                                    <h2>
                                        {{ data_accesos.dateTime_ExitAccess ? data_accesos.dateTime_ExitAccess : $t('pendiente') }}
                                    </h2>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <h2>
                                        {{$t('comentarios')}}
                                    </h2>
                                </th>
                                <td>
                                    <h2>
                                        {{ (data_accesos.comments === '' || data_accesos.comments === null) ? $t('sin_comentarios') : data_accesos.comments }}
                                    </h2>
                                </td>
                            </tr>
                        </table>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog scrollable v-model="dialog_accesos_company" max-width="500px">
                <v-card color="blue-grey lighten-4" class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>{{$t('detalle_access')}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialog_accesos_company = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text v-if="data_accesos_company.user">
                        <v-img
                                :src="data_accesos_company.user.avatar"
                                position="center center"
                                class="grey lighten-2"
                        ></v-img>
                        <br>
                        <table id="datas">
                            <tr>
                                <th>
                                    <h2>
                                        {{$t('Visitante')}}:
                                    </h2>
                                </th>
                                <td>
                                    <h2>
                                        {{ data_accesos_company.user.first_name}} {{ data_accesos_company.user.last_name}}
                                    </h2>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <h2>
                                        {{$t('Empresa')}}:
                                    </h2>
                                </th>
                                <td>
                                    <h2>
                                        {{ data_accesos_company.company_name}}
                                    </h2>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <h2>
                                        {{$t('Caseta')}}:
                                    </h2>
                                </th>
                                <td>
                                    <h2>
                                        {{ data_accesos_company.guardhouse_name}}
                                    </h2>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <h2>
                                        {{$t('hora_acceso')}}
                                    </h2>
                                </th>
                                <td>
                                    <h2>
                                        {{ data_accesos_company.dateTime_EntranceAccess}}
                                    </h2>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <h2>
                                        {{$t('hora_salida')}}
                                    </h2>
                                </th>
                                <td>
                                    <h2>
                                        {{ data_accesos_company.dateTime_ExitAccess ? data_accesos_company.dateTime_ExitAccess : $t('pendiente') }}
                                    </h2>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <h2>
                                        {{$t('comentarios')}}
                                    </h2>
                                </th>
                                <td>
                                    <h2>
                                        {{ (data_accesos_company.comments === '' || data_accesos_company.comments === null) ? $t('sin_comentarios') : data_accesos_company.comments }}
                                    </h2>
                                </td>
                            </tr>
                        </table>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog scrollable v-model="dialog_accesos_without_code" max-width="500px">
                <v-card color="blue-grey lighten-4" class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>{{$t('detalle_access')}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialog_accesos_without_code = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-img
                                :src="data_accesos_without_code.photo"
                                position="center center"
                                class="grey lighten-2"
                        ></v-img>
                        <table id="datas">
                            <tr>
                                <th>
                                    <h2>
                                        {{$t('Visitante')}}:
                                    </h2>
                                </th>
                                <td>
                                    <h2>
                                        {{ data_accesos_without_code.name_guest}}
                                    </h2>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <h2>
                                        {{$t('hora_acceso')}}
                                    </h2>
                                </th>
                                <td>
                                    <h2>
                                        {{ data_accesos_without_code.dateTime_EntranceAccess}}
                                    </h2>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <h2>
                                        {{$t('hora_salida')}}
                                    </h2>
                                </th>
                                <td>
                                    <h2>
                                        {{ data_accesos_without_code.dateTime_ExitAccess ? data_accesos_without_code.dateTime_ExitAccess : "Salida no registrada" }}
                                    </h2>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <h2>
                                        {{$t('comentarios')}}
                                    </h2>
                                </th>
                                <td>
                                    <h2>
                                        {{ data_accesos_without_code.comments}}
                                    </h2>
                                </td>
                            </tr>
                        </table>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog scrollable v-model="dialog_detail_invit_recibidas" width="700">
                <v-card color="blue-grey lighten-4" class="elevation-0">
                    <v-toolbar class="mb-0" dark color="primary">
                        <v-toolbar-title>
                            {{$t('detalle_invit_recibidas')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialog_detail_invit_recibidas = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div class="text-xs-center" v-if="Object.keys(info_invitation_recibida).length > 0">
                            <v-layout justify-center class="text-xs-center" row wrap>
                                <v-flex xs12>
                                    <v-layout align-center justify-center row wrap>
                                        <v-flex class="text-xs-center" xs12>
                                            <table id="datas">
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('fecha_inv')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida.invitation.dateInv}}  {{ info_invitation_recibida.invitation.timeInv}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Anfitrion')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida.host.first_name}}
                                                            {{ info_invitation_recibida.host.last_name}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Parque')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida.invitation.park_name}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Asunto')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida.invitation.subject}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Notas')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida.invitation.notes}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('mensaje_vehiculo')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida.invitation.vehicle ? $t('Si') : "No" }}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr v-if="info_invitation_recibida.invitation.typeInv === 2">
                                                    <th>
                                                        <h2>
                                                            {{$t('dias_validos')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2 v-if="info_invitation_recibida.invitation.diary.includes('0') === true">
                                                            {{ $t('Lunes') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida.invitation.diary.includes('1') === true">
                                                            {{ $t('Martes') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida.invitation.diary.includes('2') === true">
                                                            {{ $t('Miercoles') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida.invitation.diary.includes('3') === true">
                                                            {{ $t('Jueves') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida.invitation.diary.includes('4') === true">
                                                            {{ $t('Viernes') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida.invitation.diary.includes('5') === true">
                                                            {{ $t('Sabado') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida.invitation.diary.includes('6') === true">
                                                            {{ $t('Domingo') }}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr v-if="info_invitation_recibida.invitation.typeInv === 2">
                                                    <th>
                                                        <h2>
                                                            {{$t('fecha_expiracion')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida.invitation.expiration }}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr v-if="info_invitation_recibida.confirmed === false">
                                                    <td colspan="2">
                                                        <h2>
                                                            {{$t('asistira')}}:
                                                        </h2>
                                                        <v-btn
                                                                color="primary"
                                                                :loading="loading_si"
                                                                @click="confirmar_invitacion(info_invitation_recibida.invitation.id, 'True')"
                                                                dark>{{$t('Si')}}
                                                            <v-icon dark right>check_circle</v-icon>
                                                        </v-btn>
<!--                                                        <v-btn-->
<!--                                                                color="red"-->
<!--                                                                :loading="loading_no"-->
<!--                                                                @click="confirmar_invitacion(info_invitation_recibida.invitation.id, 'False')"-->
<!--                                                                dark>No-->
<!--                                                            <v-icon dark right>block</v-icon>-->
<!--                                                        </v-btn>-->
                                                    </td>
                                                </tr>
                                            </table>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog scrollable v-model="dialog_detail_invit_recibidas_empresa" width="700">
                <v-card color="blue-grey lighten-4" class="elevation-0">
                    <v-toolbar class="mb-0" dark color="primary">
                        <v-toolbar-title>
                            {{$t('detalle_invit_recibidas')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialog_detail_invit_recibidas_empresa = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div class="text-xs-center" v-if="info_invitation_recibida_empresa.length > 0">
                            <v-layout justify-center class="text-xs-center" row wrap>
                                <v-flex xs12>
                                    <v-layout align-center justify-center row wrap>
                                        <v-flex class="text-xs-center" xs12>
                                            <table id="datas">
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('fecha_inv')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida_empresa[0].dateInv}}  {{ info_invitation_recibida_empresa[0].timeInv}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Anfitrion')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida_empresa[0].hostFirstName}}
                                                            {{ info_invitation_recibida_empresa[0].hostLastName}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <!--                                                <tr>-->
                                                <!--                                                    <th>-->
                                                <!--                                                        <h2>-->
                                                <!--                                                            {{$t('Empresa')}}:-->
                                                <!--                                                        </h2>-->
                                                <!--                                                    </th>-->
                                                <!--                                                    <td>-->
                                                <!--                                                        <h2>-->
                                                <!--                                                            {{ info_invitation_recibida[0].empresa}}-->
                                                <!--                                                        </h2>-->
                                                <!--                                                    </td>-->
                                                <!--                                                </tr>-->
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Area')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida_empresa[0].areaName}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Asunto')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida_empresa[0].asunto}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Notas')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida_empresa[0].notas}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('mensaje_vehiculo')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida_empresa[0].automovil ? $t('Si') : "No" }}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('equipo_seguridad')}}
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h3>
                                                            <div v-for="(equipo, index) in info_invitation_recibida_empresa[0].secEqu" v-bind:key="equipo.index">
                                                                <h3>{{index + 1}} .- {{ equipo.nameEquipment }}</h3>
                                                            </div>
                                                        </h3>
                                                    </td>
                                                </tr>
                                                <tr v-if="info_invitation_recibida_empresa[0].typeInv === 2">
                                                    <th>
                                                        <h2>
                                                            {{$t('dias_validos')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2 v-if="info_invitation_recibida_empresa[0].diary.includes('0') === true">
                                                            {{ $t('Lunes') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida_empresa[0].diary.includes('1') === true">
                                                            {{ $t('Martes') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida_empresa[0].diary.includes('2') === true">
                                                            {{ $t('Miercoles') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida_empresa[0].diary.includes('3') === true">
                                                            {{ $t('Jueves') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida_empresa[0].diary.includes('4') === true">
                                                            {{ $t('Viernes') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida_empresa[0].diary.includes('5') === true">
                                                            {{ $t('Sabado') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida_empresa[0].diary.includes('6') === true">
                                                            {{ $t('Domingo') }}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr v-if="info_invitation_recibida_empresa[0].typeInv === 2">
                                                    <th>
                                                        <h2>
                                                            {{$t('fecha_expiracion')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida_empresa[0].expiration }}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr v-if="info_invitation_recibida_empresa[0].confirmed === false">
                                                    <td colspan="2">
                                                        <h2>
                                                            {{$t('asistira')}}:
                                                        </h2>
                                                        <v-btn
                                                                color="primary"
                                                                :loading="loading_si"
                                                                @click="confirmar_invitacion_empresa(info_invitation_recibida_empresa[0].qr_code, 'True')"
                                                                dark>{{$t('Si')}}
                                                            <v-icon dark right>check_circle</v-icon>
                                                        </v-btn>
<!--                                                        <v-btn-->
<!--                                                                color="red"-->
<!--                                                                :loading="loading_no"-->
<!--                                                                @click="confirmar_invitacion_empresa(info_invitation_recibida_empresa[0].qr_code, 'False')"-->
<!--                                                                dark>No-->
<!--                                                            <v-icon dark right>block</v-icon>-->
<!--                                                        </v-btn>-->
                                                    </td>
                                                    <!--                                                    <td>-->
                                                    <!--                                                        <h2>-->
                                                    <!--                                                            {{ info_invitation_recibida[0].expiration }}-->
                                                    <!--                                                        </h2>-->
                                                    <!--                                                    </td>-->
                                                </tr>
                                            </table>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog scrollable v-model="dialog_detail_invit" width="500">
                <v-card color="blue-grey lighten-4" class="elevation-0">
                    <v-toolbar class="mb-0" dark color="primary">
                        <v-toolbar-title>
                            {{$t('detalle_invit')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialog_detail_invit = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div class="text-xs-center" v-if="Object.keys(info_invitation).length > 0">
                            <v-layout justify-center class="text-xs-center" row wrap>
                                <v-flex xs12>
                                    <h2>{{$t('info_invitado')}}</h2>
                                    <br>
                                    <v-layout align-center justify-center row wrap>
                                        <v-flex class="text-xs-center" xs12>
                                            <v-img
                                                    :src="info_invitation.guests[index].user.avatar"
                                                    position="center center"
                                                    class="grey lighten-2"
                                            ></v-img>
                                        </v-flex>
                                        <v-flex class="text-xs-center" xs12>
                                            <table id="datas">
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('fecha_inv')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation.dateInv}}  {{ info_invitation.timeInv}}
                                                        </h2>
<!--                                                        <v-btn color="red"-->
<!--                                                               @click="setChangeHour(info_invitation.qr_code, info_invitation.timeInv)"-->
<!--                                                        >{{$t('modificar_hora')}}-->
<!--                                                        </v-btn>-->
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Visitante')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation.guests[index].user.first_name}}
                                                            {{ info_invitation.guests[index].user.last_name}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('celular')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation.guests[index].user.celular}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Asunto')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation.subject}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr v-if="info_invitation.typeInv === 2">
                                                    <th>
                                                        <h2>
                                                            {{$t('dias_validos')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2 v-if="info_invitation.diary.includes('0') === true">
                                                            {{ $t('Lunes') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation.diary.includes('1') === true">
                                                            {{ $t('Martes') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation.diary.includes('2') === true">
                                                            {{ $t('Miercoles') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation.diary.includes('3') === true">
                                                            {{ $t('Jueves') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation.diary.includes('4') === true">
                                                            {{ $t('Viernes') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation.diary.includes('5') === true">
                                                            {{ $t('Sabado') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation.diary.includes('6') === true">
                                                            {{ $t('Domingo') }}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr v-if="info_invitation.typeInv === 2">
                                                    <th>
                                                        <h2>
                                                            {{$t('fecha_expiracion')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation.expiration }}
                                                        </h2>
                                                    </td>
                                                </tr>
                                            </table>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-layout calign-center justify-center fill-height>
                <v-flex>
                    <v-card class="elevation-5">
                        <v-card-text>
                            <h3>{{$t('mostrando_historial_dia')}} </h3>
                            <v-form
                                    @submit.prevent="submit()">
                                <v-layout class="align-center " row wrap>
                                    <v-flex xs12 md6>
                                        <v-menu
                                                v-model="calendario"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="computedInitialDateFormatted"
                                                        prepend-icon="event"
                                                        name="date"
                                                        :label="$t('Fecha_ini')"
                                                        :hint="$t('formato_fecha')"
                                                        persistent-hint
                                                        readonly
                                                        v-on="on"
                                                        :error-messages="errores.date"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    :locale="$t('region')"
                                                    v-model="date"
                                                    @input="calendario = false">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-menu
                                                v-model="calendario2"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="computedFinalDateFormatted"
                                                        prepend-icon="event"
                                                        name="date2"
                                                        :label="$t('Fecha_fin')"
                                                        :hint="$t('formato_fecha')"
                                                        persistent-hint
                                                        readonly
                                                        v-on="on"
                                                        :error-messages="errores.date2"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    :locale="$t('region')"
                                                    v-model="date2"
                                                    @input="calendario2 = false, submit()">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-btn
                                                color="primary"
                                                type="submit"
                                                large
                                        >{{ $t('Filtrar') }}
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-alert
                                        :value=alerta
                                        type="warning"
                                        outline
                                        transition="scale-transition"
                                >
                                    Fallo con el Servidor
                                </v-alert>
                            </v-form>
                            <v-tabs
                                    grow
                                    fixed-tabs
                                    color="transparent"
                                    slider-color="primary">
                                <v-tab v-if="getProfile.roll === 4">
                                    <v-icon left>inbox</v-icon>
                                    {{$t('recibidos')}}
                                </v-tab>
                                <v-tab v-if="getProfile.roll === 4">
                                    <v-icon left>send</v-icon>
                                    {{$t('enviados')}}
                                </v-tab>
                                <v-tab v-if="getProfile.roll === 4">
                                    <v-icon left>compare_arrows</v-icon>
                                    {{$t('Accesos')}}
                                </v-tab>
                                <v-tab>
                                    <v-icon left>qr_code_scanner</v-icon>
                                    Accesos con codigo
                                </v-tab>
                                <v-tab>
                                    <v-icon left>exit_to_app</v-icon>
                                    {{$t('accesos_sin_codigo')}}
                                </v-tab>
                                <v-tab>
                                    <v-icon left>business</v-icon>
                                    Accesos Proveedores Externos
                                </v-tab>
                                <v-tab-item v-if="getProfile.roll === 4">
                                    <v-tabs
                                            grow
                                            fixed-tabs
                                            color="transparent"
                                            slider-color="primary">
                                        <v-tab v-if="getProfile.roll === 4">
                                            <v-icon left>inbox</v-icon>
                                            {{$t('Parques')}}
                                        </v-tab>
                                        <v-tab v-if="getProfile.roll === 4">
                                            <v-icon left>inbox</v-icon>
                                            {{$t('Empresas')}}
                                        </v-tab>
                                        <v-tab-item v-if="getProfile.roll === 4">
                                            <v-data-table
                                                    :headers="headersRecieved"
                                                    :loading="loading_data_invitaciones_recibidas"
                                                    :items="invitaciones_recibidas"
                                                    :rows-per-page-text="$t('filas_por_pagina')"
                                                    :rows-per-page-items="[
                                                                {text: '5', value: 5},
                                                                {text: '10', value: 10},
                                                                {text: '25', value: 25},
                                                                {text: this.$t('todos'), value: -1}]"
                                                    class="elevation-1"
                                                    :no-data-text="$t('no_registros_invit')"
                                            >
                                                <template v-slot:items="props">
                                                    <td align="center">
                                                        <v-icon
                                                                large
                                                                class="mr-2"
                                                                @click="get_detail_recibidas(props.item)"
                                                        >
                                                            search
                                                        </v-icon>
                                                    </td>
                                                    <td v-if="props.item.invitation.typeInv === 0" align="center">{{ $t('normal') }}</td>
                                                    <td v-if="props.item.invitation.typeInv === 1" align="center">{{ $t('empresarial') }}</td>
                                                    <td v-if="props.item.invitation.typeInv === 2" align="center">{{ $t('recurrente') }}</td>
                                                    <td align="center">{{ props.item.confirmed === true ? $t('Si') : 'No'}}</td>
                                                    <td align="center">{{ props.item.invitation.dateInv }} {{ props.item.invitation.timeInv }}</td>
                                                    <td align="center">{{ props.item.host.first_name}} {{ props.item.host.last_name}}</td>
                                                    <td align="center">{{ props.item.invitation.park_name }}</td>
                                                    <td align="center">{{ props.item.invitation.subject }}</td>
                                                    <td align="center">{{ props.item.invitation.vehicle ? $t('Si') : "No" }}</td>
                                                </template>
                                                <template v-slot:rows-per-page-text="props">
                                                    Hola
                                                </template>
                                                <template v-slot:pageText="props">
                                                    {{props.rowsPerPage}}
                                                    {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                                </template>
                                            </v-data-table>
                                        </v-tab-item>
                                        <v-tab-item v-if="getProfile.roll === 4">
                                            <v-data-table
                                                    :headers="headersRecievedEmpresas"
                                                    :loading="loading_data_invitaciones_recibidas_empresa"
                                                    :items="invitaciones_recibidas_empresa"
                                                    :rows-per-page-text="$t('filas_por_pagina')"
                                                    :rows-per-page-items="[
                                                                {text: '5', value: 5},
                                                                {text: '10', value: 10},
                                                                {text: '25', value: 25},
                                                                {text: this.$t('todos'), value: -1}]"
                                                    class="elevation-1"
                                                    :no-data-text="$t('no_registros_invit')"
                                            >
                                                <template v-slot:items="props">
                                                    <td class="justify-center layout px-0">
                                                        <v-icon
                                                                large
                                                                class="mr-2"
                                                                @click="get_detail_recibidas_empresa(props.item.id)"
                                                        >
                                                            search
                                                        </v-icon>
                                                    </td>
                                                    <td v-if="props.item.typeInv === 0">{{ $t('normal') }}</td>
                                                    <td v-if="props.item.typeInv === 1">{{ $t('empresarial') }}</td>
                                                    <td v-if="props.item.typeInv === 2">{{ $t('recurrente') }}</td>
                                                    <td v-if="props.item.confirmed === true">{{ $t('Si') }}</td>
                                                    <td v-if="props.item.confirmed === false">No</td>
                                                    <td>{{ props.item.dateInv }} {{ props.item.timeInv }}</td>
                                                    <td>{{ props.item.hostFirstName }} {{ props.item.hostLastName}}</td>
                                                    <!--                                    <td>{{ props.item.companyName }}</td>-->
                                                    <td>{{ props.item.areaName }}</td>
                                                    <td>{{ props.item.asunto }}</td>
                                                    <td align="center">{{ props.item.automovil ? $t('Si') : "No" }}</td>
                                                </template>
                                                <template v-slot:rows-per-page-text="props">
                                                    Hola
                                                </template>
                                                <template v-slot:pageText="props">
                                                    {{props.rowsPerPage}}
                                                    {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                                </template>
                                            </v-data-table>
                                        </v-tab-item>
                                    </v-tabs>
                                </v-tab-item>
                                <v-tab-item v-if="getProfile.roll === 4">
                                    <v-data-table
                                            :headers="headersSent"
                                            :loading="loading_data_invitaciones"
                                            :items="invitaciones"
                                            expand
                                            :rows-per-page-text="$t('filas_por_pagina')"
                                            :rows-per-page-items="[
                                                                {text: '5', value: 5},
                                                                {text: '10', value: 10},
                                                                {text: '25', value: 25},
                                                                {text: this.$t('todos'), value: -1}]"
                                            class="elevation-1"
                                            :no-data-text="$t('no_registros_invit')"
                                    >
                                        <template v-slot:items="props">
                                            <tr @click="props.item.guests.length > 1 ? props.expanded = !props.expanded : null">
                                                <td align="center">
                                                    <v-icon
                                                            :disabled="props.item.guests.length > 1 ? true : false"
                                                            medium
                                                            class="mr-2"
                                                            @click="get_detail(props.item, 0)"
                                                    >
                                                        search
                                                    </v-icon>
                                                    <v-icon
                                                            :disabled="props.item.guests.length > 1 ? true : false"
                                                            medium
                                                            color="red"
                                                            @click="dialog_elimnar = true, id_invitacion_eliminar = props.item.id, id_invitacion_guest = props.item.guests[0].user.id"
                                                    >
                                                        delete
                                                    </v-icon>
                                                    <v-icon
                                                            v-if="props.item.guests.length > 1 "
                                                            medium
                                                            @click=""
                                                    >
                                                        add
                                                    </v-icon>
                                                </td>
                                                <td v-if="props.item.typeInv === 0" align="center">{{ $t('normal') }}</td>
                                                <td v-if="props.item.typeInv === 1" align="center">{{ $t('empresarial') }}</td>
                                                <td v-if="props.item.typeInv === 2" align="center">{{ $t('recurrente') }}</td>
                                                <td align="center">
                                                    <div  align="center" v-for="(guest, index) in props.item.guests" v-bind:key="index">
                                                        {{ guest.confirmed === true ? $t('Si') : 'No'}}
                                                    </div>
                                                </td>
                                                <td align="center">{{ props.item.dateInv }} {{ props.item.timeInv }}</td>
                                                <td align="center">
                                                    <div  align="center" v-for="(guest, index) in props.item.guests" v-bind:key="index">
                                                        {{guest.user.first_name}} {{guest.user.last_name}}
                                                    </div>
                                                </td>
                                                <td align="center">{{ props.item.vehicle ? $t('Si') : "No" }}</td>
                                            </tr>
                                        </template>
                                        <template v-slot:expand="props">
                                            <v-card align="center">
                                                <table>
                                                    <tr>
                                                        <th>{{$t('acciones')}}</th>
                                                        <th>{{$t('Tipo')}}</th>
                                                        <th>{{$t('asistira')}}</th>
                                                        <th>{{$t('fecha_hora')}}</th>
                                                        <th>{{$t('Visitante')}}</th>
                                                        <th>{{$t('mensaje_vehiculo')}}</th>
                                                    </tr>
                                                    <tr  align="center" v-for="(guest, index) in props.item.guests" v-bind:key="index">
                                                        <td align="center">
                                                            <v-icon
                                                                    medium
                                                                    class="mr-2"
                                                                    @click="get_detail(props.item, index)"
                                                            >
                                                                search
                                                            </v-icon>
                                                            <v-icon
                                                                    medium
                                                                    color="red"
                                                                    @click="dialog_elimnar = true, id_invitacion_eliminar = props.item.id, id_invitacion_guest = guest.user.id"
                                                            >
                                                                delete
                                                            </v-icon>
                                                        </td>
                                                        <td v-if="props.item.typeInv === 0" align="center">{{ $t('normal') }}</td>
                                                        <td v-if="props.item.typeInv === 1" align="center">{{ $t('empresarial') }}</td>
                                                        <td v-if="props.item.typeInv === 2" align="center">{{ $t('recurrente') }}</td>
                                                        <td align="center">
                                                            {{ guest.confirmed === true ? $t('Si') : 'No'}}
                                                        </td>
                                                        <td align="center">{{ props.item.dateInv }} {{ props.item.timeInv }}</td>
                                                        <td align="center">
                                                            {{guest.user.first_name}} {{guest.user.last_name}}
                                                        </td>
                                                        <td align="center">{{ props.item.vehicle ? $t('Si') : "No" }}</td>
                                                    </tr>
                                                </table>
                                            </v-card>
                                        </template>
                                        <template v-slot:rows-per-page-text="props">
                                            Hola
                                        </template>
                                        <template v-slot:pageText="props">
                                            {{props.rowsPerPage}}
                                            {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                        </template>
                                    </v-data-table>
                                </v-tab-item>

                                <v-tab-item v-if="getProfile.roll === 4">
                                    <v-tabs
                                            grow
                                            fixed-tabs
                                            color="transparent"
                                            slider-color="primary">
                                        <v-tab v-if="getProfile.roll === 4">
                                            <v-icon left>inbox</v-icon>
                                            {{$t('Parque')}}
                                        </v-tab>
                                        <v-tab v-if="getProfile.roll === 4">
                                            <v-icon left>inbox</v-icon>
                                            {{$t('Empresas')}}
                                        </v-tab>
                                        <v-tab-item v-if="getProfile.roll === 4">
                                            <v-data-table
                                                    :headers="headers3"
                                                    :loading="loading_data_accesos"
                                                    :items="accesos"
                                                    :rows-per-page-text="$t('filas_por_pagina')"
                                                    :rows-per-page-items="[
                                                        {text: '5', value: 5},
                                                        {text: '10', value: 10},
                                                        {text: '25', value: 25},
                                                        {text: this.$t('todos'), value: -1}
                                                    ]"
                                                        class="elevation-1"
                                                    :no-data-text="$t('no_registros_accesos')"
                                            >
                                                <template v-slot:items="props">
                                                    <td class="justify-center layout px-0">
                                                        <v-icon
                                                                medium
                                                                class="mr-2"
                                                                @click="fill_fields2(props.item),
                                                dialog_accesos = true"
                                                        >
                                                            search
                                                        </v-icon>
                                                    </td>
                                                    <td>{{ props.item.user.first_name }} {{props.item.user.last_name}}</td>
                                                    <td v-if="props.item.entrance_vigilant !== null">{{ props.item.entrance_vigilant.user.first_name}} {{ props.item.entrance_vigilant.user.last_name}}</td>
                                                    <td v-else>{{$t('pendiente')}}</td>
                                                    <td>{{ props.item.dateTime_EntranceAccess }}</td>
                                                    <td v-if="props.item.exit_vigilant !== null">{{ props.item.exit_vigilant.user.first_name}} {{ props.item.exit_vigilant.user.last_name}}</td>
                                                    <td v-else>{{$t('pendiente')}}</td>
                                                    <td>{{ props.item.dateTime_ExitAccess === null ? $t('pendiente') : props.item.dateTime_ExitAccess}}</td>
                                                    <!--                                    <td>{{ props.item.hostFirstName}} {{ props.item.hostLastName }}</td>-->
                                                </template>
                                                <template v-slot:pageText="props">
                                                    {{props.rowsPerPage}}
                                                    {{$t('Accesos')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                                </template>
                                            </v-data-table>
                                        </v-tab-item>
                                        <v-tab-item v-if="getProfile.roll === 4">
                                            <v-data-table
                                                    :headers="headers_access_company
"
                                                    :loading="loading_data_accesos_company"
                                                    :items="accesos_company"
                                                    :rows-per-page-text="$t('filas_por_pagina')"
                                                    :rows-per-page-items="[
                                                                {text: '5', value: 5},
                                                                {text: '10', value: 10},
                                                                {text: '25', value: 25},
                                                                {text: this.$t('todos'), value: -1}]"
                                                    class="elevation-1"
                                                    :no-data-text="$t('no_registros_invit')"
                                            >
                                                <template v-slot:items="props">
                                                    <td class="justify-center layout px-0">
                                                        <v-icon
                                                                medium
                                                                class="mr-2"
                                                                @click="fill_fields_access_company(props.item), dialog_accesos_company = true"
                                                        >
                                                            search
                                                        </v-icon>
                                                    </td>
                                                    <td>{{ props.item.user.first_name }} {{props.item.user.last_name}}</td>
                                                    <td>{{ props.item.company_name }}</td>
                                                    <td v-if="props.item.entrance_vigilant !== null">{{ props.item.entrance_vigilant.user.first_name}} {{ props.item.entrance_vigilant.user.last_name}}</td>
                                                    <td v-else>{{$t('pendiente')}}</td>
                                                    <td>{{ props.item.dateTime_EntranceAccess }}</td>
                                                    <td v-if="props.item.exit_vigilant !== null">{{ props.item.exit_vigilant.user.first_name}} {{ props.item.exit_vigilant.user.last_name}}</td>
                                                    <td v-else>{{$t('pendiente')}}</td>
                                                    <td>{{ props.item.dateTime_ExitAccess === null ? $t('pendiente') : props.item.dateTime_ExitAccess}}</td>
                                                    <!--                                    <td>{{ props.item.hostFirstName}} {{ props.item.hostLastName }}</td>-->
                                                </template>
                                                <template v-slot:pageText="props">
                                                    {{props.rowsPerPage}}
                                                    {{$t('Accesos')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                                </template>
                                            </v-data-table>
                                        </v-tab-item>
                                    </v-tabs>
                                </v-tab-item>

                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text>
                                            <v-data-table
                                                    :headers="headers_qr_access"
                                                    :loading="loading_qr_access_logs"
                                                    :items="qr_access_logs"
                                                    :rows-per-page-text="$t('filas_por_pagina')"
                                                    :rows-per-page-items="[
                                                        {text: '20', value: 20},
                                                        {text: '50', value: 50},
                                                        {text: '100', value: 100},
                                                        {text: '200', value: 200}
                                                    ]"
                                                    class="elevation-1"
                                                    :no-data-text="$t('no_registros_accesos')"
                                            >
                                                <template v-slot:items="props">
                                                    <td>{{ props.item.source_display || props.item.source }}</td>
                                                    <td>{{ props.item.guest_name || $t('pendiente') }}</td>
                                                    <td>{{ props.item.company_name || '-' }}</td>
                                                    <td>{{ props.item.guardhouse_name || '-' }}</td>
                                                    <td>{{ props.item.entrance_guard_name || $t('pendiente') }}</td>
                                                    <td>{{ props.item.entrance_time ? formatAccessDateTime(props.item.entrance_time) : $t('pendiente') }}</td>
                                                    <td>{{ props.item.exit_guard_name || $t('pendiente') }}</td>
                                                    <td>{{ props.item.exit_time ? formatAccessDateTime(props.item.exit_time) : $t('pendiente') }}</td>
                                                    <td>{{ props.item.status_display || '-' }}</td>
                                                </template>
                                                <template v-slot:pageText="props">
                                                    {{props.rowsPerPage}}
                                                    Accesos QR {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ qrAccessTotal }}
                                                </template>
                                            </v-data-table>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>

                                <v-tab-item>
                                    <v-data-table
                                            :headers="headers4"
                                            :loading="loading_data_accesos_without_code"
                                            :items="accesos_without_code"
                                            :rows-per-page-text="$t('filas_por_pagina')"
                                            :rows-per-page-items="[
                                        {text: '5', value: 5},
                                        {text: '10', value: 10},
                                        {text: '25', value: 25},
                                        {text: this.$t('todos'), value: -1}
                                    ]"
                                            class="elevation-1"
                                            :no-data-text="$t('no_registros_accesos')"
                                    >
                                        <template v-slot:items="props">
                                            <td class="justify-center layout px-0">
                                                <v-icon
                                                        medium
                                                        class="mr-2"
                                                        @click="fill_fields(props.item),
                                                dialog_accesos_without_code = true"
                                                >
                                                    search
                                                </v-icon>
                                            </td>
                                            <td>{{ props.item.name_guest }}</td>
                                            <td>{{ props.item.entrance_vigilant_name }}</td>
                                            <td>{{ props.item.dateTime_EntranceAccess }}</td>
                                            <td>{{ props.item.exit_vigilant_name === null ? $t('pendiente') : props.item.exit_vigilant_name }}</td>
                                            <td v-if="props.item.dateTime_ExitAccess === null">
                                                <div v-if="getProfile.roll === 3">
                                                    <v-btn
                                                            color="primary"
                                                            @click="firmar(props.item.id)">
                                                        {{$t('firmar')}}
                                                    </v-btn>
                                                </div>
                                                <div v-else>
                                                    {{ $t('pendiente')}}
                                                </div>
                                            </td>
                                            <td v-else>
                                                {{ props.item.dateTime_ExitAccess }}
                                            </td>
                                            <!--                                    <td>{{ props.item.hostFirstName}} {{ props.item.hostLastName }}</td>-->
                                        </template>
                                        <template v-slot:pageText="props">
                                            {{props.rowsPerPage}}
                                            {{$t('Accesos')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                        </template>
                                    </v-data-table>
                                </v-tab-item>

                                <!-- Tab: Accesos Proveedores Externos -->
                                <v-tab-item>
                                    <!-- Feedback Alert -->
                                    <v-alert
                                        v-if="showFeedback"
                                        :type="feedbackType"
                                        :icon="feedbackType === 'success' ? 'check_circle' : feedbackType === 'error' ? 'error' : 'info'"
                                        dismissible
                                        class="ma-4"
                                        @input="showFeedback = false"
                                    >
                                        {{ feedbackMessage }}
                                    </v-alert>

                                    <v-data-table
                                            :headers="headersExternalProviders"
                                            :loading="loadingExternalProviders"
                                            :items="externalProvidersAccess"
                                            :rows-per-page-text="$t('filas_por_pagina')"
                                            :rows-per-page-items="[
                                        {text: '5', value: 5},
                                        {text: '10', value: 10},
                                        {text: '25', value: 25},
                                        {text: this.$t('todos'), value: -1}
                                    ]"
                                            class="elevation-1"
                                            :no-data-text="$t('no_registros_accesos')"
                                    >
                                        <template v-slot:items="props">
                                            <td class="justify-center layout px-0">
                                                <v-icon
                                                        medium
                                                        class="mr-2"
                                                        @click="viewExternalProviderDetail(props.item)"
                                                >
                                                    search
                                                </v-icon>
                                            </td>
                                            <td>{{ props.item.proveedor_nombre }}</td>
                                            <td>{{ props.item.empresa_nombre }}</td>
                                            <td>{{ props.item.servicio.name }}</td>
                                            <td>{{ props.item.vigilante_entrada_nombre || $t('pendiente') }}</td>
                                            <td>{{ formatAccessDateTime(props.item.hora_entrada) }}</td>
                                            <td>{{ props.item.vigilante_salida_nombre === null ? $t('pendiente') : props.item.vigilante_salida_nombre }}</td>
                                            <td v-if="props.item.hora_salida === null">
                                                <div v-if="getProfile.roll === 3">
                                                    <v-btn
                                                            color="primary"
                                                            small
                                                            @click="openSignExitDialog(props.item)">
                                                        {{$t('firmar')}}
                                                    </v-btn>
                                                </div>
                                                <div v-else>
                                                    {{ $t('pendiente')}}
                                                </div>
                                            </td>
                                            <td v-else>
                                                {{ formatAccessDateTime(props.item.hora_salida) }}
                                            </td>
                                        </template>
                                        <template v-slot:pageText="props">
                                            {{props.rowsPerPage}}
                                            Accesos {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                        </template>
                                    </v-data-table>
                                </v-tab-item>
                            </v-tabs>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <!-- Diálogo para Ver Detalles de Acceso de Proveedor Externo -->
        <v-dialog v-model="dialogExternalProviderDetail" scrollable max-width="700px">
            <v-card v-if="selectedExternalProviderDetail" color="blue-grey lighten-4" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Detalles del Acceso - Proveedor Externo</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="red" icon @click="dialogExternalProviderDetail = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pa-4">
                    <!-- Información del Proveedor -->
                    <div class="mb-4">
                        <h3 class="headline primary--text mb-3">Información del Proveedor</h3>
                        <table class="info-table">
                            <tr>
                                <th>Proveedor:</th>
                                <td>{{ selectedExternalProviderDetail.proveedor.first_name }} {{ selectedExternalProviderDetail.proveedor.last_name }}</td>
                            </tr>
                            <tr>
                                <th>Empresa:</th>
                                <td>{{ selectedExternalProviderDetail.empresa_nombre }}</td>
                            </tr>
                            <tr>
                                <th>Servicio:</th>
                                <td>
                                    <strong>{{ selectedExternalProviderDetail.servicio.name }}</strong><br>
                                    <small class="grey--text">{{ selectedExternalProviderDetail.servicio.description }}</small>
                                </td>
                            </tr>
                        </table>
                    </div>

                    <v-divider class="my-4"></v-divider>

                    <!-- Información de Entrada -->
                    <div class="mb-4">
                        <h3 class="headline primary--text mb-3">Registro de Entrada</h3>
                        <table class="info-table">
                            <tr>
                                <th>Hora Entrada:</th>
                                <td>{{ formatAccessDateTime(selectedExternalProviderDetail.hora_entrada) }}</td>
                            </tr>
                            <tr>
                                <th>Vigilante Entrada:</th>
                                <td>{{ selectedExternalProviderDetail.vigilante_entrada_nombre || 'No registrado' }}</td>
                            </tr>
                            <tr v-if="selectedExternalProviderDetail.ine_photo_entrada">
                                <th>Foto INE (Entrada):</th>
                                <td>
                                    <v-img
                                        :src="selectedExternalProviderDetail.ine_photo_entrada"
                                        max-width="300"
                                        max-height="200"
                                        contain
                                        class="rounded"
                                    ></v-img>
                                </td>
                            </tr>
                        </table>
                    </div>

                    <v-divider class="my-4" v-if="selectedExternalProviderDetail.hora_salida"></v-divider>

                    <!-- Información de Salida (si existe) -->
                    <div v-if="selectedExternalProviderDetail.hora_salida" class="mb-4">
                        <h3 class="headline primary--text mb-3">Registro de Salida</h3>
                        <table class="info-table">
                            <tr>
                                <th>Hora Salida:</th>
                                <td>{{ formatAccessDateTime(selectedExternalProviderDetail.hora_salida) }}</td>
                            </tr>
                            <tr>
                                <th>Vigilante Salida:</th>
                                <td>{{ selectedExternalProviderDetail.vigilante_salida_nombre || 'No registrado' }}</td>
                            </tr>
                            <tr v-if="selectedExternalProviderDetail.duracion_minutos">
                                <th>Duración:</th>
                                <td>{{ selectedExternalProviderDetail.duracion_minutos }} minutos</td>
                            </tr>
                            <tr v-if="selectedExternalProviderDetail.ine_photo_salida">
                                <th>Foto INE (Salida):</th>
                                <td>
                                    <v-img
                                        :src="selectedExternalProviderDetail.ine_photo_salida"
                                        max-width="300"
                                        max-height="200"
                                        contain
                                        class="rounded"
                                    ></v-img>
                                </td>
                            </tr>
                        </table>
                    </div>

                    <!-- Estado -->
                    <v-divider class="my-4"></v-divider>
                    <div class="text-center">
                        <v-chip
                            :color="selectedExternalProviderDetail.estado === 'ACTIVO' ? 'amber' : 'green'"
                            text-color="white"
                            large
                        >
                            Estado: {{ selectedExternalProviderDetail.estado }}
                        </v-chip>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Diálogo para Firmar Salida de Proveedor Externo -->
        <v-dialog v-model="dialogSignExit" max-width="400px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Registrar Salida</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="white" flat icon @click="dialogSignExit = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="py-5">
                    <div class="text-center mb-4">
                        <v-icon size="60" color="primary" class="mb-3">exit_to_app</v-icon>
                        <h3 class="headline">{{ selectedAccessToSign ? selectedAccessToSign.proveedor_nombre : '' }}</h3>
                        <p class="subtitle-1 grey--text">{{ selectedAccessToSign ? selectedAccessToSign.empresa_nombre : '' }}</p>
                    </div>

                    <v-divider class="my-4"></v-divider>

                    <div class="info-box pa-3 mb-3" style="background-color: #f5f5f5; border-radius: 4px;">
                        <p class="mb-1">
                            <strong>Hora Entrada:</strong><br>
                            {{ selectedAccessToSign ? formatAccessDateTime(selectedAccessToSign.hora_entrada) : '' }}
                        </p>
                        <p class="mb-0">
                            <strong>Hora Salida:</strong><br>
                            <span class="primary--text" style="font-weight: bold;">Se registrará ahora</span>
                        </p>
                    </div>

                    <v-alert type="info" icon="info" outline class="my-3">
                        La salida se registrará automáticamente con la hora actual y tu usuario como vigilante.
                    </v-alert>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pa-3">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="dialogSignExit = false">
                        {{$t('Cancelar')}}
                    </v-btn>
                    <v-btn
                        color="success"
                        :loading="loadingSignExit"
                        @click="signExit"
                        large
                    >
                        <v-icon left>check_circle</v-icon>
                        Confirmar Salida
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import {mapGetters, mapState} from 'vuex'
    import moment from 'moment'

    export default {
        name: "records_no_code",
        data: () => ({
            alerta: false,
            calendario: false,
            calendario2: false,
            fecha_actual: '',
            date: '',
            date2: '',
            errores: [],
            search: '',
            headers3: [],
            headers_access_company: [],
            headers4: [],
            headers_qr_access: [],
            headersRecieved: [],
            headersRecievedEmpresas: [],
            headersSent: [],
            invitaciones:[],
            invitaciones_recibidas:[],
            invitaciones_recibidas_empresa:[],
            accesos_without_code: [],
            accesos: [],
            loading_data_invitaciones: false,
            loading_data_invitaciones_recibidas: false,
            loading_data_invitaciones_recibidas_empresa: false,
            loading_data_accesos_without_code: false,
            loading_data_accesos: false,
            loading_qr_access_logs: false,
            yyyy: '',
            mm: '',
            dd: '',
            yyyy2: '',
            mm2: '',
            dd2: '',
            dialog_accesos_without_code: false,
            dialog_accesos: false,
            dialog_detail_invit_recibidas: false,
            dialog_detail_invit_recibidas_empresa: false,
            dialog_detail_invit: false,
            data_accesos: [],
            data_accesos_without_code: [],
            info_invitation_recibida: '',
            info_invitation_recibida_empresa: '',
            info_invitation: '',
            loading_si: false,
            loading_no: false,
            dialog_elimnar: false,
            id_invitacion_eliminar: '',
            id_invitacion_guest: '',
            index: -1,
            loading_data_accesos_company: false,
            accesos_company: [],
            data_accesos_company: [],
            dialog_accesos_company: false,
            qr_access_logs: [],
            qrAccessTotal: 0,
            qrCounts: {
                qr_enterprise: 0,
                qr_park_invitation: 0,
                qr_shipment: 0
            },
            qrCurrentPage: 1,
            qrHasNext: false,
            qrHasPrevious: false,
            // Accesos Proveedores Externos
            externalProvidersAccess: [],
            loadingExternalProviders: false,
            headersExternalProviders: [],
            dialogExternalProviderDetail: false,
            selectedExternalProviderDetail: null,
            loadingExternalProviderDetail: false,
            dialogSignExit: false,
            selectedAccessToSign: null,
            loadingSignExit: false,
            feedbackMessage: '',
            feedbackType: '',
            showFeedback: false,
        }),
        created: function(){
            this.fecha_actual = this.get_current_date()
            this.date = this.fecha_actual
            this.date2 = this.fecha_actual
            console.log(this.date, this.date2)
            this.get_access_without_code_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
            this.fetch_qr_access_logs(1)
            this.getExternalProvidersAccess()
            if (this.getProfile.roll === 4) {
                this.getAccessPark(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.getAccessParkCompany(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.get_invitaciones_recibidas(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.get_invitaciones_recibidas_empresa(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.get_invitaciones(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
            }
        },
        beforeUpdate() {
            this.headersSent = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    value: 'name',
                    sortable: false
                },
                {
                    text: this.$t('Tipo'),
                    align: 'center',
                    sortable: true,
                    value: 'tipo'
                },
                {
                    text: this.$t('asistira'),
                    align: 'center',
                    sortable: true,
                    value: 'guests'
                },
                {
                    text: this.$t('fecha_hora'),
                    align: 'center',
                    sortable: true,
                    value: 'fecha_hora_invitacion'
                },
                {
                    text: this.$t('Visitantes'),
                    align: 'center',
                    sortable: true,
                    value: 'guests'
                },
                // {
                //     text: this.$t('Empresa'),
                //     align: 'center',
                //     sortable: true,
                //     value: 'empresa'
                // },
                {
                    text: this.$t('mensaje_vehiculo'),
                    align: 'center',
                    sortable: true,
                    value: 'vehicle'
                }
            ],
            this.headersRecieved = [
                {
                    text: this.$t('detalle'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: this.$t('Tipo'),
                    align: 'center',
                    sortable: true,
                    value: 'invitation.typeInv'
                },
                {
                    text: this.$t('asistira'),
                    align: 'center',
                    sortable: true,
                    value: 'confirmed'
                },
                {
                    text: this.$t('fecha_hora'),
                    align: 'center',
                    sortable: true,
                    value: 'invitation.dateInv'
                },
                {
                    text: this.$t('Anfitrion'),
                    align: 'center',
                    sortable: true,
                    value: 'host.first_name'
                },
                // {
                //     text: this.$t('Empresa'),
                //     align: 'left',
                //     sortable: true,
                //     value: 'empresa'
                // },
                {
                    text: this.$t('Parque'),
                    align: 'center',
                    sortable: true,
                    value: 'invitation.park_name'
                },
                {
                    text: this.$t('Asunto'),
                    align: 'center',
                    sortable: true,
                    value: 'invitation.subject'
                },
                {
                    text: this.$t('mensaje_vehiculo'),
                    align: 'center',
                    sortable: true,
                    value: 'invitation.vehicle'
                }
            ],
            this.headersRecievedEmpresas = [
                {
                    text: this.$t('detalle'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: this.$t('Tipo'),
                    align: 'left',
                    sortable: true,
                    value: 'tipo'
                },
                {
                    text: this.$t('asistira'),
                    align: 'left',
                    sortable: true,
                    value: 'confirmed'
                },
                {
                    text: this.$t('fecha_hora'),
                    align: 'left',
                    sortable: true,
                    value: 'fecha_hora_invitacion'
                },
                {
                    text: this.$t('Anfitrion'),
                    align: 'left',
                    sortable: true,
                    value: 'hostFirstName'
                },
                // {
                //     text: this.$t('Empresa'),
                //     align: 'left',
                //     sortable: true,
                //     value: 'empresa'
                // },
                {
                    text: this.$t('Area'),
                    align: 'left',
                    sortable: true,
                    value: 'areaName'
                },
                {
                    text: this.$t('Asunto'),
                    align: 'left',
                    sortable: true,
                    value: 'guestCellPhone'
                },
                {
                    text: this.$t('mensaje_vehiculo'),
                    align: 'center',
                    sortable: true,
                    value: 'hostFirstName'
                }
            ],
            this.headers3 = [
                {
                    text: this.$t('detalle'),
                    align: 'center',
                    sortable: false,
                    value: 'details'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'user.first_name'
                },
                {
                    text: this.$t('Vigilante_entrada'),
                    align: 'left',
                    sortable: true,
                    value: 'entrance_vigilant.user.first_name'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'dateTime_EntranceAccess'
                },
                {
                    text: this.$t('Vigilante_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'exit_vigilant.user.first_name'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'dateTime_ExitAccess'
                },
            ]
            this.headers_access_company = [
                {
                    text: this.$t('detalle'),
                    align: 'center',
                    sortable: false,
                    value: 'details'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'user.first_name'
                },
                {
                    text: this.$t('Empresa'),
                    align: 'left',
                    sortable: true,
                    value: 'company_name'
                },
                {
                    text: this.$t('Vigilante_entrada'),
                    align: 'left',
                    sortable: true,
                    value: 'entrance_vigilant.user.first_name'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'dateTime_EntranceAccess'
                },
                {
                    text: this.$t('Vigilante_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'exit_vigilant.user.first_name'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'dateTime_ExitAccess'
                },
            ]
            this.headers4 = [
                {
                    text: this.$t('detalle'),
                    align: 'center',
                    sortable: false,
                    value: 'details'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'name_guest'
                },
                {
                    text: this.$t('Vigilante_entrada'),
                    align: 'left',
                    sortable: true,
                    value: 'entrance_vigilant_name'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'dateTime_EntranceAccess'
                },
                {
                    text: this.$t('Vigilante_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'exit_vigilant_name'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'dateTime_ExitAccess'
                },
            ]
            this.headers_qr_access = [
                {
                    text: 'Origen',
                    align: 'left',
                    sortable: true,
                    value: 'source_display'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'guest_name'
                },
                {
                    text: this.$t('Empresa'),
                    align: 'left',
                    sortable: true,
                    value: 'company_name'
                },
                {
                    text: this.$t('Caseta'),
                    align: 'left',
                    sortable: true,
                    value: 'guardhouse_name'
                },
                {
                    text: this.$t('Vigilante_entrada'),
                    align: 'left',
                    sortable: true,
                    value: 'entrance_guard_name'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'entrance_time'
                },
                {
                    text: this.$t('Vigilante_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'exit_guard_name'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'exit_time'
                },
                {
                    text: 'Estatus',
                    align: 'left',
                    sortable: true,
                    value: 'status_display'
                },
            ]
            this.headersExternalProviders = [
                {
                    text: this.$t('detalle'),
                    align: 'center',
                    sortable: false,
                    value: 'details'
                },
                {
                    text: 'Proveedor',
                    align: 'left',
                    sortable: true,
                    value: 'proveedor_nombre'
                },
                {
                    text: this.$t('Empresa'),
                    align: 'left',
                    sortable: true,
                    value: 'empresa_nombre'
                },
                {
                    text: 'Servicio',
                    align: 'left',
                    sortable: true,
                    value: 'servicio.name'
                },
                {
                    text: this.$t('Vigilante_entrada'),
                    align: 'left',
                    sortable: true,
                    value: 'vigilante_entrada_nombre'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'hora_entrada'
                },
                {
                    text: this.$t('Vigilante_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'vigilante_salida_nombre'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'hora_salida'
                },
            ]
        },
        computed: {
            ...mapState(['language']),
            ...mapGetters(['getProfile']),
            computedInitialDateFormatted () {
                return this.formatDate(this.date)
            },
            computedFinalDateFormatted () {
                return this.formatDate(this.date2)
            }
        },
        methods:{
            get_current_date: function (){
                var today = new Date();
                this.dd = today.getDate();
                this.mm = today.getMonth()+1;
                this.yyyy = today.getFullYear();
                this.dd2 = today.getDate();
                this.mm2 = today.getMonth()+1;
                this.yyyy2 = today.getFullYear();

                if(this.dd<10)
                {
                    this.dd='0'+this.dd;
                }
                if(this.dd2<10)
                {
                    this.dd2='0'+this.dd2;
                }

                if(this.mm<10)
                {
                    this.mm='0'+this.mm;
                }
                if(this.mm2<10)
                {
                    this.mm2='0'+this.mm2;
                }
                today = this.yyyy + '-' + this.mm + '-' + this.dd;
                return today
            },
            split_date: function(date, date2) {
                var arr = date.split('-')
                var arr2 = date2.split('-')

                this.yyyy = arr[0]
                this.mm = arr[1]
                this.dd = arr[2 ]

                this.yyyy2 = arr2[0]
                this.mm2 = arr2[1]
                this.dd2 = arr2[2 ]
            },
            get_invitaciones_recibidas: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_invitaciones_recibidas = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/InvitationPark/received/' + yyyy + '/'  + mm + '/' + dd + '/' + yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.data === "")
                            this.invitaciones_recibidas = []
                        else
                            this.invitaciones_recibidas = response.data
                        this.loading_data_invitaciones_recibidas = false
                    })
                    .catch(error => {
                        this.loading_data_invitaciones_recibidas = false
                        console.log(error)
                    })
            },
            get_invitaciones_recibidas_empresa: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_invitaciones_recibidas_empresa = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get_inv/userByDateRange/' + yyyy + '/'  + mm + '/' + dd + '/' + yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.data === "")
                            this.invitaciones_recibidas_empresa = []
                        else
                            this.invitaciones_recibidas_empresa = response.data
                        this.loading_data_invitaciones_recibidas_empresa = false
                    })
                    .catch(error => {
                        this.loading_data_invitaciones_recibidas_empresa = false
                        console.log(error)
                    })
            },
            get_invitaciones: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                console.log(yyyy, mm ,dd, '-', yyyy2, mm2, dd2)
                this.loading_data_invitaciones = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/InvitationPark/sent/' + yyyy + '/'  + mm + '/' + dd + '/' + yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        var algo = this.removeDuplicates(response.data)
                        console.log('Algo == ')
                        console.log(algo)
                        this.invitaciones = algo
                        this.loading_data_invitaciones = false
                    })
                    .catch(error => {
                        this.loading_data_invitaciones = false
                        console.log(error)
                    })

            },
            get_access_without_code_by_date: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_accesos_without_code = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/AccessParkNoCode/createList/' + yyyy + '/'  + mm + '/' + dd + '/' + yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if(response.data.length > 0)
                            this.accesos_without_code = response.data
                        else
                            this.accesos_without_code = []
                        this.loading_data_accesos_without_code = false
                    })
                    .catch(error => {
                        this.loading_data_accesos_without_code = false
                        console.log(error)
                    })

            },
            getAccessPark: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_accesos = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/InvitationAccessPark/ListAll/' + yyyy + '/'  + mm + '/' + dd + '/' + yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if(response.data.length > 0)
                            this.accesos = response.data
                        else
                            this.accesos = []
                        this.loading_data_accesos = false
                    })
                    .catch(error => {
                        this.loading_data_accesos = false
                        console.log(error)
                    })

            },
            getAccessParkCompany: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_accesos_company = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/AccessParkCode/ListAll/' + yyyy + '/'  + mm + '/' + dd + '/' + yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if(response.data.length > 0)
                            this.accesos_company = response.data
                        else
                            this.accesos_company = []
                        this.loading_data_accesos_company = false
                    })
                    .catch(error => {
                        this.loading_data_accesos_company = false
                        console.log(error)
                    })

            },
            fetch_qr_access_logs(page = 1) {
                this.loading_qr_access_logs = true
                const params = {
                    start_date: this.date,
                    end_date: this.date2,
                    page: page
                }

                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/InvitationAccessPark/guard/access-logs/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language,
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    params: params
                }

                axios(config)
                    .then(response => {
                        const data = response.data || {}
                        const resultsData = data.results || {}
                        if (Array.isArray(resultsData)) {
                            this.qr_access_logs = resultsData
                            this.qrCounts = data.count_by_source || {
                                qr_enterprise: 0,
                                qr_park_invitation: 0,
                                qr_shipment: 0
                            }
                        } else {
                            this.qr_access_logs = Array.isArray(resultsData.items) ? resultsData.items : []
                            this.qrCounts = resultsData.count_by_source || {
                                qr_enterprise: 0,
                                qr_park_invitation: 0,
                                qr_shipment: 0
                            }
                        }
                        this.qrAccessTotal = data.count || 0
                        this.qrCurrentPage = page
                        this.qrHasNext = !!data.next
                        this.qrHasPrevious = !!data.previous
                        this.loading_qr_access_logs = false
                    })
                    .catch(error => {
                        this.loading_qr_access_logs = false
                        this.qr_access_logs = []
                        this.qrAccessTotal = 0
                        this.qrHasNext = false
                        this.qrHasPrevious = false
                        let message = 'Error al consultar accesos con codigo'
                        if (error.response && error.response.status === 400) {
                            message = 'Parametros invalidos: revisa fechas'
                        } else if (error.response && error.response.status === 401) {
                            message = 'Sesion no valida. Inicia sesion nuevamente'
                        } else if (error.response && error.response.status === 403) {
                            message = 'No autorizado: solo vigilante de parque'
                        }
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'error')
                        this.$store.commit('snackbar_change_message', message)
                        console.log(error)
                    })
            },
            fill_fields (item){
                this.data_accesos_without_code = item
                console.log(this.data_accesos_without_code)
            },
            fill_fields2 (item) {
                this.data_accesos = item
                console.log(this.data_accesos)
            },
            fill_fields_access_company (item) {
                this.data_accesos_company = item
                console.log(this.data_accesos_company)
            },
            firmar: function(pk){
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/AccessParkNoCode/updateDetail/' + pk,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config)
                    .then(response => {
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'success')
                        this.$store.commit('snackbar_change_message', this.$t('salida_exitosa'))
                        setTimeout(this.clear, 3000)
                        this.get_access_without_code_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        console.log('FIRMADO')
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            eliminar_invitacion () {
                const config = {
                    method: 'delete',
                    url: 'https://empresa-service.intrare.app/InvitationPark/delete/' + this.id_invitacion_eliminar,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        idGuest: this.id_invitacion_guest
                    }
                };
                axios(config).then(ok => {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'warning')
                    this.$store.commit('snackbar_change_message', this.$t('mensaje_invitacion_delete'))
                    setTimeout(this.clear, 3000);
                    this.dialog_elimnar = false
                    this.get_invitaciones(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                })
                    .catch(error => {
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                    })
            },
            confirmar_invitacion(pk, confirmacion){
                if(confirmacion === 'True')
                    this.loading_si = true
                else
                    this.loading_no = true
                const config = {
                    method: 'PATCH',
                    url: 'https://empresa-service.intrare.app/InvitationPark/confirm/'+ pk,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(ok => {
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_invitacion_confirmada'))
                        setTimeout(this.clear, 3000);
                        this.dialog_detail_invit_recibidas = false
                        this.get_invitaciones_recibidas(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        if(confirmacion === 'True')
                            this.loading_si = false
                        else
                            this.loading_no = false
                    })
                    .catch(error => {
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data){
                            this.errores = error.response.data
                            this.errores_seg = error.response.data.id_usuario
                            console.log(this.errores)}
                        if(confirmacion === 'True')
                            this.loading_si = false
                        else
                            this.loading_no = false
                    })
            },
            confirmar_invitacion_empresa(a_qr, confirmacion){
                if(confirmacion === 'True')
                    this.loading_si = true
                else
                    this.loading_no = true
                const config = {
                    method: 'PATCH',
                    url: 'https://empresa-service.intrare.app/setConfirmed_Appointment/'+ a_qr +'/' + confirmacion + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(ok => {
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_invitacion_confirmada'))
                        setTimeout(this.clear, 3000);
                        this.dialog_detail_invit_recibidas_empresa = false
                        this.get_invitaciones_recibidas_empresa(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        if(confirmacion === 'True')
                            this.loading_si = false
                        else
                            this.loading_no = false
                    })
                    .catch(error => {
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data){
                            this.errores = error.response.data
                            this.errores_seg = error.response.data.id_usuario
                            console.log(this.errores)}
                        if(confirmacion === 'True')
                            this.loading_si = false
                        else
                            this.loading_no = false
                    })
            },
            clear () {
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_activate_false')
            },
            submit: function() {
                this.split_date(this.date, this.date2)
                this.get_invitaciones_recibidas(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.get_invitaciones_recibidas_empresa(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.get_invitaciones(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.get_access_without_code_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.getAccessPark(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.getAccessParkCompany(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.fetch_qr_access_logs(1)
            },
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            formatAccessDateTime (dateTime) {
                if (!dateTime) return null
                const parsed = moment.parseZone(dateTime)
                if (!parsed.isValid()) return dateTime
                return parsed.format('DD/MM/YYYY HH:mm')
            },
            get_detail_recibidas_empresa(id) {
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get_inv/' + id,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.info_invitation_recibida_empresa = response.data
                        this.dialog_detail_invit_recibidas_empresa = true
                    })
                    .catch(error => {
                        this.dialog_detail_invit_recibidas_empresa = false
                        console.log(error)
                    })
            },
            get_detail_recibidas(item) {
                this.info_invitation_recibida = item
                this.dialog_detail_invit_recibidas = true
            },
            get_detail(item, index) {
                console.log(item, index)
                this.index = index
                this.info_invitation = item
                this.dialog_detail_invit = true
            },
            // Métodos para Accesos de Proveedores Externos
            getExternalProvidersAccess() {
                this.loadingExternalProviders = true;
                const parkId = localStorage.getItem('id_parque');

                const config = {
                    method: 'get',
                    url: `https://empresa-service.intrare.app/accesos/proveedores/?parque_id=${parkId}`,
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };

                axios(config)
                    .then(response => {
                        this.externalProvidersAccess = response.data;
                        this.loadingExternalProviders = false;
                    })
                    .catch(error => {
                        this.feedbackMessage = 'Error al cargar accesos';
                        this.feedbackType = 'error';
                        this.showFeedback = true;
                        this.loadingExternalProviders = false;
                    });
            },
            openSignExitDialog(access) {
                this.selectedAccessToSign = access;
                this.dialogSignExit = true;
            },
            signExit() {
                if (!this.selectedAccessToSign) {
                    return;
                }

                this.loadingSignExit = true;
                const accessId = this.selectedAccessToSign.id;

                const config = {
                    method: 'patch',
                    url: `https://empresa-service.intrare.app/accesos/proveedores/${accessId}/salida/`,
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };

                axios(config)
                    .then(response => {
                        // Mostrar feedback visual
                        this.feedbackMessage = `¡Salida registrada exitosamente para ${response.data.proveedor_nombre}!`;
                        this.feedbackType = 'success';
                        this.showFeedback = true;

                        this.loadingSignExit = false;
                        this.dialogSignExit = false;

                        // Recargar los accesos después de 2 segundos
                        setTimeout(() => {
                            this.getExternalProvidersAccess();
                        }, 2000);
                    })
                    .catch(error => {
                        const errorMsg = error.response && error.response.data && error.response.data.mensaje
                            ? error.response.data.mensaje
                            : error.message;

                        // Mostrar feedback visual de error
                        this.feedbackMessage = ` Error al registrar salida: ${errorMsg}`;
                        this.feedbackType = 'error';
                        this.showFeedback = true;

                        this.loadingSignExit = false;
                    });
            },
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n)
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n)
                }
                return new File([u8arr], filename, {type:mime})
            },
            viewExternalProviderDetail(access) {
                this.loadingExternalProviderDetail = true;

                const config = {
                    method: 'get',
                    url: `https://empresa-service.intrare.app/accesos/proveedores/${access.id}/`,
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };

                axios(config)
                    .then(response => {
                        this.selectedExternalProviderDetail = response.data;
                        this.dialogExternalProviderDetail = true;
                        this.loadingExternalProviderDetail = false;
                    })
                    .catch(error => {
                        this.feedbackMessage = '❌ Error al cargar detalles del acceso';
                        this.feedbackType = 'error';
                        this.showFeedback = true;
                        this.loadingExternalProviderDetail = false;
                    });
            },
            removeDuplicates(arrayIn) {
                var arrayOut = []
                arrayIn.forEach(item=> {
                    try {
                        if (JSON.stringify(arrayOut[arrayOut.length-1].id) !== JSON.stringify(item.id)) {
                            arrayOut.push(item);
                        }
                    } catch(err) {
                        arrayOut.push(item);
                    }
                })
                return arrayOut
            }
        }
    }
</script>


<style scoped>
    .error {
        font-weight: bold;
        color: red;
    }

    #datas {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #datas td, #datas th {
        padding: 8px;
    }

    #datas tr:nth-child(even){background-color: #f2f2f2;}

    #datas tr:hover {background-color: #ddd;}

    #datas th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #002b48;
        color: white;
    }

    .info-table {
        width: 100%;
        border-collapse: collapse;
    }

    .info-table tr {
        border-bottom: 1px solid #e0e0e0;
    }

    .info-table th {
        padding: 12px;
        text-align: left;
        font-weight: bold;
        background-color: #f5f5f5;
        width: 150px;
        vertical-align: top;
    }

    .info-table td {
        padding: 12px;
        text-align: left;
    }

    .info-table tr:hover {
        background-color: #f9f9f9;
    }

    .rounded {
        border-radius: 4px;
    }
</style>
